import moment from "moment";
import "moment/locale/de";

const formatBoolean = (value) => {
  if (value === true) {
    return "Ja";
  }
  return "Nein";
};

const formatDateTime = (isoDateString) => {
  const date = moment(isoDateString);

  if (!date.isValid()) {
    return "-"; // Ungültiges Datum -> leerer String
  }

  return date.locale("de").format("DD.MM.YYYY, HH:mm");
};

const asText = (value) => (value == null ? "" : `${value}`);

const asArray = (value) => (Array.isArray(value) ? value : []);

const TableFormatter = {
  formatBoolean,
  formatDateTime,
  asText,
  asArray,
};

export { asArray, asText, formatBoolean, formatDateTime };

export default TableFormatter;
